module.exports = __webpack_public_path__ + "img/frames.eb4f3326.png";